function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.19 2H7.82C4.18 2 2.01 4.17 2.01 7.81v8.37c0 3.64 2.17 5.81 5.81 5.81h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.41 14.17a4.341 4.341 0 00-4.09-2.91h-.02l-2.06.01h-.01c-.76 0-1.42-.51-1.62-1.24.89-.28 1.54-1.11 1.54-2.09 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .89.54 1.66 1.3 2v4.34c-.76.3-1.3 1.04-1.3 1.9 0 1.13.92 2.05 2.05 2.05s2.05-.92 2.05-2.05c0-.87-.54-1.6-1.3-1.9v-2.02c.49.31 1.07.49 1.68.49h.01l2.06-.01c1.18-.04 2.23.72 2.65 1.82-.49.38-.81.96-.81 1.62 0 1.13.92 2.05 2.05 2.05s2.05-.92 2.05-2.05c.01-1.04-.8-1.9-1.83-2.01z"
})));